import React from 'react';
import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import isNil from 'lodash/isNil';
import { PERMISSIONS } from '~/mst/models/permissions/types';
import useMst from '~/hooks/use_mst';

type ProtectedRouteProps = {
  permission?: PERMISSIONS;
  children: React.ReactElement;
};

function ProtectedRoute(props: ProtectedRouteProps) {
  const { permission, children } = props;
  const { auth } = useMst();

  if (isNil(permission) || auth.user?.hasPermission(permission)) {
    return children;
  }
  return <Navigate to="/" />;
}

export default observer(ProtectedRoute);
